import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: '/inference',
      component: () => import("@/views/base/Index"),
      children: [
        // Dashboard
        {
          name: "dashboard",
          path: "dashboard",
          component: () => import("@/views/dashboard/Dashboard"),
        },
        // Inference
        {
          name: "inference",
          path: "inference",
          component: () => import("@/views/inference/Inference"),
        },
        {
          name: "inferenceSetting",
          path: "inference/inferenceSetting/:uuid?",
          props: true,
          component: () => import("@/views/inference/InferenceSetting"),
        },
        // Recognition
        {
          name: "recognition",
          path: "recognition",
          component: () => import("@/views/recognition/Recognition"),
          children: [
            {
              name: "camera",
              path: "camera",
              props: true,
              component: () => import("@/views/recognition/Camera"),
            },
            {
              name: "licensePlate",
              path: "licensePlate/:uuid?",
              props: true,
              component: () => import("@/views/recognition/LicensePlate"),
            },
          ],
        },
        // Search
        {
          name: "search",
          path: "search",
          component: () => import("@/views/search/Search"),
          children: [
            {
              name: "search_licensePlate",
              path: "licensePlate",
              props: true,
              component: () => import("@/views/search/LicensePlate"),
            },
          ],
        },
        // System
        {
          name: "system",
          path: "system",
          component: () => import("@/views/system/System"),
          children: [
            {
              name: "systemBase",
              path: "base",
              component: () => import("@/views/system/Base"),
            },
            {
              name: "maintain",
              path: "maintain",
              component: () => import("@/views/system/Maintain"),
            },
            {
              name: "main_file",
              path: "mainfile",
              component: () => import("@/views/system/Mainfile"),
            },
            {
              name: "endpoint",
              path: "endpoint",
              component: () => import("@/views/system/Endpoint"),
            },
            {
              name: "vms",
              path: "vms",
              component: () => import("@/views/system/Vms"),
            },
            {
              name: "license",
              path: "license",
              component: () => import("@/views/system/License"),
            },
          ],
        },
        // Pages
        {
          name: "user-profile",
          path: "pages/user",
          component: () => import("@/views/base/pages/UserProfile"),
        },
        {
          name: "notifications",
          path: "components/notifications",
          component: () => import("@/views/base/component/Notifications"),
        },
        {
          name: "icons",
          path: "components/icons",
          component: () => import("@/views/base/component/Icons"),
        },
        {
          name: "typography",
          path: "components/typography",
          component: () => import("@/views/base/component/Typography"),
        },
        // Tables
        {
          name: "rtables",
          path: "tables/regular-tables",
          component: () => import("@/views/base/tables/RegularTables"),
        },
        // Maps
        {
          name: "google",
          path: "maps/google-maps",
          component: () => import("@/views/base/maps/GoogleMaps"),
        },
        // Upgrade
        {
          name: "upgrade",
          path: "upgrade",
          component: () => import("@/views/base/Upgrade"),
        },
      ],
    },
  ],
});
